import React, { useState } from "react";
import { ConfigProvider, Tabs, theme } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import UiButton from "../../../ui/UiButton";
import OrgTabPageShell from "../OrgTabPageShell";
import IpWhitelisting from "./IpWhitelisting";
import DynamicRolesAndForms from "./DynamicRolesAndForms";
import BillingPolicies from "./BillingPolicies";
import useUrlParam from "../../../../hooks/useUrlParam";
import styles from "./Settings.module.css";

const SECTIONS = ["ip-whitelisting", "dynamic-roles-and-forms", "billing-policies"];

const Settings = ({ sideContent }) => {
  const { token } = theme.useToken();
  const [section, setSection] = useUrlParam("section", {
    defaultValue: "ip-whitelisting",
    replace: true,
  });
  const activeKey = SECTIONS.includes(section) ? section : "ip-whitelisting";
  const [createRoleOpen, setCreateRoleOpen] = useState(false);

  const tabBarExtraContent =
    activeKey === "dynamic-roles-and-forms" ? (
      <UiButton icon={<PlusOutlined />} onClick={() => setCreateRoleOpen(true)}>
        Create Role
      </UiButton>
    ) : null;

  return (
    <OrgTabPageShell sideContent={sideContent}>
      <div style={{ width: "100%" }}>
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                cardPadding: "6px 14px",
                colorBorderSecondary: "transparent",
                itemSelectedColor: "#101828",
                itemHoverColor: "#101828",
              },
            },
          }}
        >
          <Tabs
            className={styles.pillsTabs}
            style={{ ["--org-primary"]: token.colorPrimary }}
            activeKey={activeKey}
            onChange={(key) => setSection(key, { clear: ["role", "form"] })}
            tabBarExtraContent={tabBarExtraContent}
            items={[
              {
                key: "ip-whitelisting",
                label: "IP Whitelisting",
                children: <IpWhitelisting />,
              },
              {
                key: "dynamic-roles-and-forms",
                label: "Dynamic Roles & Forms",
                children: (
                  <DynamicRolesAndForms
                    createOpen={createRoleOpen}
                    onCreateOpenChange={setCreateRoleOpen}
                  />
                ),
              },
              {
                key: "billing-policies",
                label: "Billing Policies",
                children: <BillingPolicies />,
              },
            ]}
          />
        </ConfigProvider>
      </div>
    </OrgTabPageShell>
  );
};

export default Settings;
